const primary = '#2e5278';

export default {
  primary,
}